//core
import React from "react";
import arePropsEqual from "react-fast-compare";
import {makeStyles} from "@mui/styles";
import { Box, Tooltip } from "@mui/material";

//components
import CopyToClipboardButton from "../../../CopyToClipboard";

interface ILinkProps {
  value: string;
  width?: number;
  color?: string;
  className?: string;
  showCopyIcon?: boolean;
}

const useStyles = makeStyles({
  text: {
    color: "inherit",
    //width: "360px",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
    //wordBreak: 'break-word'
  },
  box: {
    display: "flex",
    alignItems: "center",
  }
});

const Link = ({ value, width = 360, color, className = '', showCopyIcon = false, }: ILinkProps) => {
  const styles = useStyles();

  return (
    <Box className={styles.box}>
      {!!value && !!showCopyIcon && <CopyToClipboardButton text={value} />}
      {value
        ? <Tooltip title={value}>
            <a
              href={value}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles.text} ${className}`}
              style={{ width: `${width}px`, color: color }}
            >
              { value }
            </a>
          </Tooltip>
        : '—'}
    </Box>
  );
};

export default React.memo(Link, arePropsEqual);
